/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */
import { GridProps } from './DataGrid.types';
import { DataGrid } from '../PRIVATE_DataGrid';

export type Props<D> = GridProps<D>;

export const DataGridView = function DataGridView<D>(props: GridProps<D>) {
  return <DataGrid<D> {...props} />;
};
